<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Quiz">
        <b-card-body>
  
          <!--
          <b-row>
            <b-col cols="auto" class="mr-auto">
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
              </b-form-group>
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Quiz</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
            -->  
  
          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
            <b-form-group>
              <p></p>
              <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
            </b-form-group>
          </b-col>
            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                        <b-row v-show="row.item.summary && row.item.summary.length > 0">
                            <b-col class="small">Resumo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.summary }}</b-col>
                        </b-row>
                        <b-row v-show="row.item.content && row.item.content.length > 0">
                            <b-col class="small">Conteúdo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-row>
                              <b-col sm="2" class="small">{{ (row.item.document ? 'Documento' : 'Mídia') }}:</b-col>
                              <b-col sm="10" class="small">{{ row.item.document.title }}</b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="2" class="small">Publicado por:</b-col>
                              <b-col sm="10" class="small">{{ row.item.document.publisherName }} em {{ row.item.document.publishedIn }}</b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                        
                    </b-card>
                </template>
                

                <template v-slot:cell(document)="data">
                    <b-button size="sm" variant="primary"  @click="data.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-file-pdf-o"></i></b-button>  
                </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              :title="selectedQuiz.formTitle"
              size="xl">
  
        <b-form @submit.stop.prevent="onSubmit">
  
        <div class="animated fadeIn">

          <b-card
            header-tag="header"
            footer-tag="footer"
            class="card-accent-danger"

            v-show="needReadConfirmation"

            >
            <div slot="header" >
              Leitura Obrigatória
            </div>
              
            <b-card-body>
                  <p>Antes de iniciar o questionário, por favor leia o documento:</p>
                  <p></p>

                  <b-card class="bg-primary text-center" v-show="this.selectedQuiz" v-if="this.selectedQuiz.quiz && this.selectedQuiz.quiz.document">
                    <blockquote class="card-blockquote">
                      <p>{{ this.selectedQuiz.quiz.document.title  }}</p>
                      <p class="small">{{ this.selectedQuiz.quiz.document.description  }}</p>
                      <p class="small">Publicado por {{ this.selectedQuiz.quiz.document.publisherName  }} em {{ this.selectedQuiz.quiz.document.publishedIn }}</p>
                      <p><img src="img/document.png" width="100" height="100" @click="attachmentClick()"></p>
                      
                    </blockquote>
                  </b-card>
                  
                </b-card-body>
              
              
          </b-card>

          <div id="quizform" v-show="!needReadConfirmation">
        
            <b-row>
              <b-col md="12">
                <b-form>
                  <div role="tablist">
                  
                    <b-card no-body class="mb-1" v-for="question, questionKey in shuffleArray(selectedQuiz.questions, selectedQuiz.randomQuestions)" :key="question.id">
                      <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-btn block href="#" v-b-toggle="'accordion_' + questionKey" variant="primary" class="text-left">QUESTÃO {{ questionKey+1 }}<br>{{ question.question.question }}</b-btn>
                      </b-card-header>
                      <b-collapse :id="'accordion_' + questionKey" visible  role="tabpanel">
                        <b-card-body>
                          <b-list-group v-for="resp, respKey in shuffleArray(question.responses, selectedQuiz.randomResponses)" :key="resp.id">
                            <b-list-group-item href="#" @click="saveResponse(question, question.id, question.quizUserId, question.question.id, resp.id)" :variant="question.responseId != null && question.responseId == resp.id ? 'warning' : 'default'">{{ String.fromCharCode(respKey + 65) }} - {{ resp.response }}</b-list-group-item>
                            
                          </b-list-group>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                  </div>
                </b-form>
              </b-col>
            </b-row>
    
            <b-input-group class="mb-4">
                <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
            </b-input-group>
          
            <div slot="footer" class="text-right">
              <b-button variant="github" class="mr-1 btn-brand" @click="finish(selectedQuiz.id)"><i class="fa fa-check"></i><span>Concluir</span></b-button>
            
            </div>

          </div>
                
        </div>
        </b-form>
  
      </b-modal>

      <!--<b-modal title="Documento" class="modal-danger" v-model="documentModal" @ok="documentModal = false" ok-variant="danger" hide-footer size="xl" v-if="attachment">-->
        <b-modal title="Documento" class="modal-danger" v-model="documentModal" @ok="documentModal = false" ok-variant="danger" hide-footer size="xl" v-if="this.attachment">
          <div class="ratio ratio-16x9">
              <iframe
              src="bmwagulhasnegras/docs/7.pdf"
              title="Arquivo"
              allowfullscreen
              width="100%"
              height="600px"
              ></iframe>
          </div>
      </b-modal>
  
    </div>


    
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  import { Switch as cSwitch } from '@coreui/vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch
    },
    data: () => {
      return {
        documentModal: false,
        attachment: null,
        needReadConfirmation: false,
        response: {
          "quizId": null,
          "userId": null,
          "sid": null,
          "questions": [
          ]
        },

        responseQuestion: {
          "id": null,
          "questionId": null,
          "quizUserId": null,
          "responseId": null
        },

        selectedQuiz: {
          formTitle: ''
        },
        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          key: ''
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          {key: 'show_details', label: "", thStyle: { width: "30px" } },
          {key: 'document', label: '', sortable: false, thStyle: { width: "30px" } },
          //{key: 'id' },
          {key: 'formTitle', label: 'Quiz', sortable: true },
          //{key: 'readIn', label: 'Leitura', sortable: false, thStyle: { width: "140px" } },
          {key: 'userStartDate', label: 'Início', sortable: true, thStyle: { width: "140px" } },
          {key: 'userEndDate', label: 'Término', sortable: true, thStyle: { width: "140px" } },
          
          {key: 'endDate', label: 'Limite', sortable: true, thStyle: { width: "140px" } }
          //{key: 'ispublic', label: 'Público', sortable: true, thStyle: { width: "40px" } },
          //{key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return this.filters.key == '' || item.formTitle.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {
      strToDate(dtStr) {
        if (!dtStr) return null
        let dateParts = dtStr.split("/");
        let timeParts = dateParts[2].split(" ")[1].split(":");
        dateParts[2] = dateParts[2].split(" ")[0];
        // month is 0-based, that's why we need dataParts[1] - 1
        return dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1], '00');
      },
      async confirmRead(quizUserId) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
            await axios.get(
                this.$store.state.ws_url + "/quiz/user/confirmread?quizUserId=" + quizUserId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                console.log("Confirmação de leitura: " + quizUserId)
            }).catch(function(error) {
              console.log(error)
            })
            
        
      },
      attachmentClick() {
        this.attachment = this.selectedQuiz.quiz.document; 

        if(this.attachment.files && this.attachment.files.length > 0) {
          this.documentModal = true
          this.confirmRead(this.selectedQuiz.id)
          this.editModal = false;
        }
        else {
          toast ({
                type: VueNotifications.types.error,
                title: 'Anexo',
                message: 'Nenhum arquivo vinculado ao documento.',
                timeout: 5000
              })
        }
        
      },
      shuffleArray(arr, doShuffle) {
          if(doShuffle) {
            for (let i = arr.length - 1; i > 0; i--) {
                    // Escolhendo elemento aleatório
                const j = Math.floor(Math.random() * (i + 1));
                // Reposicionando elemento
                [arr[i], arr[j]] = [arr[j], arr[i]];
            }
          }
          return arr;
      },
      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     
      async quizResponse(question, quizUserQuestionId, quizUserId, questionId, responseId) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/quiz/user/question/response?quizUserQuestionId=" + quizUserQuestionId + "&quizUserId=" + quizUserId + "&questionId=" + questionId + "&responseId=" + responseId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
          question.responseId = responseId; // ALtera na tela
          toast ({
            type: VueNotifications.types.warn,
            title: 'Salvar resposta',
            message: 'Resposta salva com sucesso!',
            timeout: 3000
          })
        }).catch(function(error) {
          toast ({
            type: VueNotifications.types.error,
            title: 'Salvar resposta',
            message: 'Erro ao salvar resposta!',
            timeout: 5000
          })
        })
      },
      saveResponse(question, quizUserQuestionId, quizUserId, questionId, responseId) {
        //console.log("quizUserQuestionId: " + quizUserQuestionId + " quizUserId: " + quizUserId + " questionId: " + questionId + " responseId: " + responseId);
        this.quizResponse(question, quizUserQuestionId, quizUserId, questionId, responseId);
      },
      async quizFinish(quizUserId) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/quiz/user/finish?quizUserId=" + quizUserId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
          toast ({
            type: VueNotifications.types.warn,
            title: 'Questionário',
            message: 'Questionário finalizado. Obrigado pelas respostas!',
            timeout: 5000
          });
          s.closeEditModal();
        }).catch(function(error) {
          toast ({
            type: VueNotifications.types.error,
            title: 'Questionário',
            message: resp.data.message,
            timeout: 5000
          })
        })
       
       
      },
      finish(quizUserId) {
        //console.log("quizUserId: " + quizUserId);
        this.quizFinish(quizUserId);
      },
      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
        console.log(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal() {
        this.needReadConfirmation = false
        if(this.selectedQuiz.quiz.readConfirmation) {
          //console.log(this.selectedQuiz)
          if(this.selectedQuiz.readIn) {
            var readTime = this.selectedQuiz.quiz.readTime ? this.selectedQuiz.quiz.readTime : 60;
            var x = new Date();
            var y = new Date(Date.parse(this.selectedQuiz.readIn))
            var z = Math.abs(x.getTime() - y.getTime())/1000

            console.log(x)
            console.log(y);
            console.log(z);

            if(z < readTime) {
              this.needReadConfirmation = true;
            } 
          }
          else {
            this.needReadConfirmation = true;
          }
        }
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items
        //console.log(items);
        //this.openEditModal(items[0])
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
            this.clearSelectedRows();
            this.quizStart(item);
      },
      async quizStart(item) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/quiz/user/start?quizId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
          s.selectedQuiz = resp.data.obj;
          s.openEditModal();
        }).catch(function(error) {
          toast ({
              type: VueNotifications.types.error,
              title: 'Questionário',
              message: error.data.message,
              timeout: 5000
            })
        })
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      toggleBusy() {
        this.isBusy = !this.isBusy
      },
      async refreshData() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/quiz?referenceTypeCode=U&referenceId=" + currentUser.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function() {
          s.items = resp.data.obj;
        }).catch(function(error) {
          console.log(error)
        })
        this.isBusy = false;
       
      }
    },
    mounted: function() {
      this.isBusy = true;
      this.refreshData();
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>